import * as React from "react";

import { Step } from "../../TourTypes";

import { ExtendedErrorLogImageContainer } from "./ExtendedErrorLog.styles";

export const extendedErrorLog: Step = {
    id: "candyform_extendederrorlog",
    header: "Подробный результат проверки",
    content: (
        <div>
            Ознакомьтесь с подробным результатом проверки отчета и скачивайте его при необходимости.
            <br />
            <ExtendedErrorLogImageContainer />
        </div>
    ),
    positions: ["right top"],
    group: ["panel"],
    order: 40,
    offset: -20,
};
